import React, { Component } from "react";

import "../CSS/style_general.css";

import RaisedButton     from "material-ui/RaisedButton";
import IconArrowForward from "material-ui/svg-icons/navigation/arrow-forward"
import IconArrowBack    from "material-ui/svg-icons/navigation/arrow-back"
import IconDone         from "material-ui/svg-icons/action/done"
import IconDoneAll      from "material-ui/svg-icons/action/done-all"
import IconClear        from "material-ui/svg-icons/content/clear"
import "../CSS/style_Index2.css"


export default class ImageSlider extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
        position : 0,
        interval : setInterval(this.next, 3000)
    }

  }

  next  = () => {
    var images = this.props.images || [];
    var pos = this.state.position;
    if(pos < images.length -1 ) ++pos;
    else pos = 0;
    if(this.state.interval != null)
        clearInterval(this.state.interval);
    this.setState({position: pos, interval : null})
  }

  back = () => {
    var images = this.props.images || [];
    var pos  = this.state.position;
    if(pos > 0) --pos;
    else pos = images.length-1;
    if(this.state.interval != null)
        clearInterval(this.state.interval);
    this.setState({position: pos, interval : null})
  }

  render() {
    const style = {
        buttons : {
            width: '-moz-fit-content',
            width: '-webkit-fit-content',
            width: 'fit-content',
            margin: "0 auto",
            background: "red"
        }
    }
    return(
        <div className="sg-image-slider">
            <div style={{margin: "0 auto"}}>
                <img src={this.props.images[this.state.position]}/>
            </div>
            <div className="clearfix">
                <div className="left" style={{height: "100%", position: "relative", zIndex : "20"}} onClick={this.back}>
                    <RaisedButton className="button-table" icon={<IconArrowBack />}  onClick={()=> this.back()}/>
                </div>
                <div className="right" style={{height: "100%", position: "relative", zIndex : "20"}} onClick={this.next}>
                    <RaisedButton className="button-table" icon={<IconArrowForward />}  onClick={()=> this.next()}/>
                </div>
            </div>
        </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/Components/component_ImageSlider.js